module.exports = __webpack_public_path__ + "static/media/notesWithAttachments.7fd09e7e.png";